import * as React from "react"
import type { SVGProps } from "react"
const SvgCloudUpload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M6.5 20.86a5.4 5.4 0 0 1-3.89-1.58A5.2 5.2 0 0 1 1 15.43q0-1.95 1.18-3.47c1.17-1.52 1.8-1.67 3.07-1.95a6.8 6.8 0 0 1 2.5-3.73A7 7 0 0 1 12 4.86q2.92 0 4.96 2.03A6.8 6.8 0 0 1 19 11.86q1.72.2 2.86 1.49a4.4 4.4 0 0 1 1.14 3q0 1.89-1.31 3.2c-1.31 1.3-1.94 1.3-3.19 1.3zm3.6-6.28.9-.87v5.15H6.5a3.4 3.4 0 0 1-2.47-1.03A3.4 3.4 0 0 1 3 15.36q0-1.46 1.02-2.48a3.4 3.4 0 0 1 2.48-1.02H7q0-2.08 1.46-3.54Q9.93 6.86 12 6.86c2.07 0 2.56.48 3.54 1.46A4.8 4.8 0 0 1 17 11.86v2h1.5q1.05 0 1.78.72.72.72.72 1.78c0 1.06-.24 1.29-.72 1.77q-.73.73-1.78.73H13V13.7l.9.87q.3.27.71.26a1 1 0 0 0 .69-.28 1 1 0 0 0 .29-.72 1 1 0 0 0-.29-.68l-2.6-2.6a1 1 0 0 0-.7-.3q-.4 0-.7.3l-2.6 2.6a1 1 0 0 0-.27.7q0 .42.27.7.3.3.71.3a1 1 0 0 0 .69-.28"
    />
  </svg>
)
export default SvgCloudUpload
